export default "__VITE_ASSET__D$OL4PeZ__"